import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AclDataModule } from '../acl-data/acl-data.module';
import { AngularMaterialModule } from '../angular-material.module';
import { AclSearchMainComponent } from './acl-search-main/acl-search-main.component';
import { SearchFieldComponent } from './search-filter/search-field/search-field.component';
import { SearchFilterComponent } from './search-filter/search-filter.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { SharedControlsModule } from '../shared-controls/shared-controls.module';
import { LinkDocumentDialogComponent } from './link-document-dialog/link-document-dialog.component';
import { LinkedViewComponent } from './linked-documents-view/linked-documents-view.component';
import { AssignLegalCounselDialogComponent } from './assign-legal-counsel-dialog/assign-legal-counsel-dialog.component';

@NgModule({
    declarations: [
        AclSearchMainComponent,
        SearchFilterComponent,
        SearchFieldComponent,
        SearchResultsComponent,
        LinkDocumentDialogComponent,
        LinkedViewComponent,
        AssignLegalCounselDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        AngularMaterialModule,
        SharedControlsModule,
        AclDataModule,
        RouterModule.forChild([]),
    ],
    exports: [LinkDocumentDialogComponent, LinkedViewComponent],
    entryComponents: [LinkDocumentDialogComponent],
})
export class AclSearchModule {}
